import { Card, CardBody, CardTitle } from 'reactstrap';
import { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';

const SalesOverview = ({totalSales,thisWeekSales,thisMonthSales,totalAppCount,thisMonthCount,months,disbursementAmounts,actualDisbursementAmounts}) => {

const [totalActualDisbursed, setTotalActualDisbursed] = useState(0);
const [MonthSalesActualDisbursed, setMonthSalesActualDisbursed] = useState(0);

useEffect(() => {
  if (actualDisbursementAmounts.length > 0) {
    setTotalActualDisbursed(actualDisbursementAmounts.reduce((a, b) => a + b, 0));
    setMonthSalesActualDisbursed(actualDisbursementAmounts[actualDisbursementAmounts.length - 1]);
  }
}, [actualDisbursementAmounts]);
  

  const currentDate = new Date();
const currentMonth = `${currentDate.getFullYear()} ${currentDate.toLocaleString("en-US", { month: "short" })}`
  
  function formatNumberWithCommas(number) {
    return number?.toLocaleString('en-IN'); 
  }

  const formatIndianAmount = (amount) => {
    if (amount >= 10000000) {
      return `${(amount / 10000000).toFixed(2)} Cr`;
    } else if (amount >= 100000) {
      return `${(amount / 100000).toFixed(2)} L`;
    } else {
      return formatNumberWithCommas(Math.round(amount));
    }
  }

  
 
  const sanitizedMonths = months.map((month) => {
    return month === null || month === undefined ? "NullMonth" : month.split(' ')[1];
});



  const optionscampaign = {
    chart: {
      id: 'basic-bar',
      animations: {
        easing: 'easeinout',
      },
      fontFamily: "'Montserrat', sans-serif",
      toolbar: {
        show: false,
      },
    },

    xaxis: {
      categories: sanitizedMonths,
      labels: {
        show: true,
        style: {
          colors: '#99abb4',
          fontSize: '12px',
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        show: true,
        style: {
          colors: '#99abb4',
          fontSize: '12px',
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 4,
    },
    colors: ['#398bf7', '#00E396'],
    stroke: {
      curve: 'straight',
      width: '3',
    },
    grid: {
      show: true,
      borderColor: 'rgba(0, 0, 0, .2)',
      strokeDashArray: 3,
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    tooltip: {
      theme: 'dark',
    },
  };
  const seriescampaign = [
    {
      name: 'LoanAmount',
      data: disbursementAmounts,
    },
    {
      name: 'DisbursedAmount',
      data: actualDisbursementAmounts,
    },
  ];





  return (
    <Card  style={{marginBottom:'20px'}}>
      <span className="lstick bg-info" ></span>
      <CardBody>
        <div class="text-muted">
          <CardTitle tag="h4">Disburements (12 months)</CardTitle>
        </div>
        <CardBody style={{ paddingLeft: '0.1px', paddingRight: '0.1px' }}>
              <div style={{  backgroundColor: '#4c8cf4', color: 'white', paddingRight: '15px',marginRight:'5px'}}>
                <div className="row text-center g-0" >
                  <div className="col-lg-4 col-md-3 col-sm-5 " >
                    <div className="p-3 w-100 text-truncate" >
                      <h6 className="text-white">Total Disbursed / Loan Amount </h6>
                      <h5 className="text-white m-b-0">₹{formatIndianAmount(Math.round(totalActualDisbursed))} / ₹{formatIndianAmount(Math.round(totalSales))}</h5>
                    </div>
                  </div>

                  <div className="col-lg-2 col-md-3 col-sm-5 " >
                    <div className="p-3 w-100 text-truncate">
                      <h6 className="text-white" >Total Count</h6>
                      <h5 className="text-white m-b-0">{totalAppCount}</h5>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-3 col-sm-5">
                    <div className="p-3 w-100 text-truncate">
                      <h6 className="text-white">This Month</h6>
                      <h5 className="text-white m-b-0">₹{thisWeekSales?.month === currentMonth ?  formatIndianAmount(Math.round(MonthSalesActualDisbursed)):"0"} / ₹{thisWeekSales?.month === currentMonth ?  formatIndianAmount(Math.round(thisMonthSales)):"0"}</h5>
                    </div>
                  </div>

                  <div className="col-lg-2 col-md-3 col-sm-5" >
                    <div className="p-3 w-100 text-truncate">
                      <h6 className="text-white">Month Count</h6>
                      <h5 className="text-white m-b-0">{thisWeekSales?.month === currentMonth ? thisMonthCount :"0"}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>

        <div className="">
          <div className="">
          <Chart options={optionscampaign} series={seriescampaign} type="line" height={300} />
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default SalesOverview;
